<template>
    <div v-if="isPc" class="container">
        <div class="certification-group" v-for="(item) in safetyData" :key="item.title">
            <img :src="item.img" class="certification-image" alt="ISO Certification" loading="lazy" />
            <div class="certification-text">
                <span class="title">{{ item.title }}</span>
                <span class="description">{{ item.desc }}</span>
            </div>
        </div>
    </div>
    <div v-else class="mob-container">
        <img :src="img_back" class="right-bottom"></img>
        <div :class="['mob-certification-group', {'mob-last-item': index === safetyData.length - 1}]" v-for="(item,index) in safetyData" :key="item.title">
            <img :src="item.img_mob" class="mob-certification-image" alt="ISO Certification" loading="lazy" />
            <div class="mob-certification-text">
                <span class="mob-title">{{ item.title }}</span>
                <span class="mob-description">{{ item.desc }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { dataReport } from "../../../../../../utils/report";

export default {
    props: {
        isPc: {
            type: Boolean,
            default: true
        },
        safetyInfo: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            img_back:'https://coss-platform.fenqile.com/platformresource200/M00/ex/20251111111010-07842b5b-adde-4c34-a05f-7432e5da5267.png'
        };
    },
    computed: {
        safetyData() {
            return this.safetyInfo?.[1]?.map(
                (item) => ({
                    title: item.title,
                    img: item.img,
                    desc: item.text,
                    img_mob: item.img_mob
                })
            )
        }
    },
    methods: {
        handleExposure() {
            if(this.isPc){
                dataReport(
                    {
                        hottag: "FQL_HOME_PC_SAFETY_ITEMS_EXPOSURE",
                        eventPosName: `分期乐网页端首页安全项曝光`,
                        eventType: 1, // 曝光
                    },
                    {items:this.safetyData}
                )
            }
            else{
                dataReport(
                    {
                        hottag: "FQL_HOME_MOB_SAFETY_ITEMS_EXPOSURE",
                        eventPosName: `分期乐移动端首页安全项曝光`,
                        eventType: 1, // 曝光
                    },
                    {items:this.safetyData}
                )
                }
        }
    },
    watch: {
        safetyData: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.handleExposure();
                }
            },
            deep: true
        }
    }
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: row;
    height: 290px;
    justify-content: space-around;
    background-color: rgb(255, 255, 255);
    border-radius: 4px;
    /* padding-left:120px;
    padding-right:120px; */
    position: relative;
}

.mob-container {
    display: flex;
    flex-direction: column;
    width: 91%;
    background: linear-gradient(180deg, rgba(175, 215, 255, 0.50) -23.31%, #FFF 14.83%);
    border-radius: 4px;
    border: 1px solid #FFF;
    padding-left: 12px;
    padding-top: 30px;
    padding-bottom: 30px;
    position: relative;
    overflow: hidden;
    align-items: flex-start;
    z-index: 0;
}

.right-bottom {
    width: 140px;
    height: 187px;
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
}

.certification-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    position: relative;
}

.mob-certification-group {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-bottom: 18px;
    position: relative;
    z-index: 2;
}

.certification-image {
    margin-top:-20px;
    width: 142px;
    height: 142px;
}

.mob-certification-image {
    width: 56px;
    height: 56px;
    margin-right:8px;
}

.cert-text {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.title {
    color: rgb(77, 131, 255);
    font-family: 'PingFang SC';
    font-size: 24px;
    font-weight: 500;
}

.mob-title {
    color: #3371FF;
    font-family: 'PingFang SC';
    font-size: 16px;
    font-weight: 500;
    margin-bottom:8px;
}

.description {
    color: rgba(65, 65, 65, 0.80);
    font-family: 'PingFang SC';
    font-size: 16px;
    font-weight: 400;
    margin-top: 14px;
    margin-bottom:0;
}

.mob-description {
    color: rgba(30, 37, 51, 0.60);
    font-family: 'PingFang SC';
    font-size: 14px;
    font-weight: 400;
    margin-top: 0;
}

.certification-text {
    margin-top: 51px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.mob-certification-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.arrow-up-container {
    position: absolute;
    top: 0;
    right: 0;
    width: 42px;
    height: 42px;
    background-color: #B2CAFF;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer; /* 可选：添加鼠标指针效果 */
    color: white; /* 设置图标颜色 */
    font-size: 28px; /* 调整图标大小 */
    border-radius: 4px;
}

/* 使用更好的选择器和定位方式 */
.certification-group:not(:last-child)::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 100px; /* 分割线高度 */
    background-color: #F2F2F2; /* 分割线颜色 */
    z-index: 1; /* 确保分割线显示在正确的层级 */
}

.mob-last-item{
    margin-bottom: 0;
}
</style>